import { render, staticRenderFns } from "./Taskbar.vue?vue&type=template&id=373f5330&"
import script from "./Taskbar.vue?vue&type=script&lang=js&"
export * from "./Taskbar.vue?vue&type=script&lang=js&"
import style0 from "./Taskbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports